import { type IMediator } from './mediator.types';

export class Mediator implements IMediator {
  readonly #services: Map<symbol, unknown> = new Map();

  public registerSingleton<T>(uniqueId: symbol, service: T): void {
    if (this.#services.has(uniqueId)) {
      throw new Error(`Service ${uniqueId.toString()} already registered.`);
    }

    this.#services.set(uniqueId, service);
  }

  public get<T>(uniqueId: symbol): T {
    const service = this.#services.get(uniqueId);

    if (!service) {
      throw new Error(`Service ${uniqueId.toString()} not registered.`);
    }

    return service as T;
  }
}
